<div
  style="
    align-content: center;
    font-size: 16px;
    color: white;
    border-radius: 0.5em;
    width: fit-content;
    padding-left: 15px;
    padding-right: 15px;
    margin: auto;
  "
  [style.background]="this.barva"
>
  {{ besedilo }}
</div>
